var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"not-found"},[_c('van-nav-bar',{attrs:{"title":"","left-text":"返回","left-arrow":""},on:{"click-left":function($event){return _vm.$router.go(-1)}}}),_c('img',{attrs:{"src":require("../assets/img/not.jpeg"),"alt":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }